<script>
import operationDialog from "@/components/common/operationDialog.vue";
import newCheckReport from "@/components/vision/newCheckReport.vue";

import { exitFullScreen } from "@/common/util.js";
import CryptoJS from 'crypto-js'
const basicLink = {
  CONTRAST_SENSITIVITY_TRAINING: "/shigongnengjiance-duibimingandu/index.html",
  WORTH_FOUR_LAMP_HOLE_CHALLENGE: `/shigongnengjiance-worth4dot/index.html`,
  PERCEPTUAL_EYE_POSITION: `/shigongnengjiance-zhijueyanwei/index.html`,
  EXTENSIVENESS_STEREOPSIS: `/shigongnengjiance-dafanweilitishi/index.html`,
  LINE_STEREOPSIS: `/shigongnengjiance-xiantiaolitishi/index.html`,
  LINE_FUSION: `/shigongnengjiance-xiantiaoronghe/index.html`,
  AMBLYOPIA_INHIBITION_EQUILIBRIUM_POINT: `/ruoshiyizhipinghengdian/index.html`,
  STRABISMUS_INHIBITION_EQUILIBRIUM_POINT: `/xieshiyizhipinghengdian/index.html`
};
const mapEyes = {
  finallyEyes: "双眼",
  finallyRight: "右眼",
  finallyLeft: "左眼"
};
export default {
  components: {
    operationDialog,
    newCheckReport
  },
  data() {
    return {
      picInfo: undefined,
      showResultImg: false,
      finished: false,
      checkList: [],
      user: {},
      sortList: [],
      activeItem: undefined,
      checkResult: {
        vision: undefined,
        worthFour: undefined,
        eyePosition: undefined,
        dafanweilitishi: undefined,
        xiantiaolitishi: undefined,
        xiantiaoronghe: undefined,
        amblyopia_blance: undefined,
        strabismus_blance: undefined
      },
      showCheckReport: false,
      htmlTitle: "",
      showQuitAlert: false,
      iframeElement: {}
    };
  },
  mounted() {
    const temp = JSON.parse(sessionStorage.getItem("batchCheck"));
    this.user = temp.user;
    this.htmlTitle = this.user.name + "视功能检测报告"
    const tempList = [];
    for (let item in basicLink) {
      if (temp.checkList.filter(o => o == item).length > 0) {
        tempList.push(item);
      }
    }
    this.iframeElement = this.$el.lastElementChild.lastElementChild;
    this.checkList = tempList;
    if (this.checkList.length > 0) {
      const activeItem = this.checkList.shift();
      this.iframeElement.src = `${this.$resourceUrl}${basicLink[activeItem]}`;
      this.fullScreen();
      window.addEventListener("message", this.getMessage);
      this.activeItem = activeItem;
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.getMessage);
    exitFullScreen();
  },
  methods: {
    getMessage(e) {
      if (this.isJsonString(e.data)) {
        let data = e.data;
        data = JSON.parse(data);

        if (data.type === "saveBtnClicked" || data.type === "sendResult") {
          if (this.activeItem !== "CONTRAST_SENSITIVITY_TRAINING") {
            this.checkResult[this.activeItem] = data.data;
          }
          console.log('>>>>>>>',  this.checkList)
          if (this.checkList.length > 0) {
            const activeItem = this.checkList.shift();
            this.iframeElement.src = `${this.$resourceUrl}${basicLink[activeItem]}`;
            this.activeItem = activeItem;
            console.log('>>>>>>>inininin',  this.iframeElement.src)
          } else {
            exitFullScreen();
            this.showCheckReport = true;
          }
        } else if (data.type === "getPixelInfo") {
          let messData = JSON.parse(localStorage.getItem("data"));
          messData.PUPIL_DISTANCE_MILLI = this.user.IPD;
          messData.age = this.user.age;
          document.querySelector(".ScreenIframe").contentWindow.focus();
          let jsonData = JSON.stringify({
            type: "getPixelInfo",
            data: messData
          });
          window.frames[0].postMessage(jsonData, "*");
          this.finished = true;
        } else if (data.type === "quit") {
          if (this.checkList.length > 0) {
            this.showQuitAlert = true;
          } else {
            exitFullScreen();
            this.showCheckReport = true;
          }
        } else if (data.type === "getImage") {
          this.checkResult[this.activeItem] = data.data.data.finallyArr;
          this.showResultImg = true;
          this.$nextTick(() => {
            this.drawLine(data.data.data.finallyArr, data.data.data.normalArr);
          });
        } else {
          console.log("data.type5", data.type);
        }
      }
    },
    isJsonString(str) {
      try {
        if (typeof JSON.parse(str) == "object") {
          return true;
        }
      } catch (e) {}
      return false;
    },
    goBack() {
      this.$router.replace("/index/homeRoute");
    },
    fullScreen() {
      var element = this.$el.lastElementChild;
      var requestMethod =
        element.requestFullScreen || //W3C
        element.webkitRequestFullScreen || //FireFox
        element.mozRequestFullScreen || //Chrome等
        element.msRequestFullscreen; //IE11
      if (requestMethod) {
        requestMethod.call(element);
      }
    },
    async saveFinshedResult(testResult) {},
    print() {
      this.$print(this.$refs.print);

      // 调用上传PDF报告的方法
      this.uploadPdfReport();
    },

    async uploadPdfReport() {
      try {
        // 获取检查项目列表
        const checkList = JSON.parse(sessionStorage.getItem("batchCheck")).checkList;

        // 使用Promise封装getPdfBlob方法，等待PDF生成
        const pdfBlob = await new Promise((resolve) => {
          this.getPdfBlob((blob, title) => {
            resolve({ blob, title });
          });
        });

        // 直接对PDF的原始数据内容进行哈希计算，而不是对生成的二进制文件
        // 因为PDF生成过程中存在浏览器渲染差异等动态因素
        const reportContent = {
          user: this.user,
          checkList: checkList,
          checkResult: this.checkResult
        };
        // 将报告内容转换为字符串并计算SHA256值
        const contentString = JSON.stringify(reportContent);
        const sha256Hash = CryptoJS.SHA256(contentString).toString();
        console.log('Report Content SHA256:', sha256Hash);

        // 检查本地存储中是否已存在该SHA256值
        const cachedReportHash = localStorage.getItem('cachedReportHash');
        console.log('cachedReportHash', cachedReportHash);
        if (cachedReportHash === sha256Hash) {
          return;
        }

        // 准备上传数据
        const patientName = this.user.name;
        const gender = this.user.gender === '男' ? 'MALE' : 'FEMALE';
        const birthday = this.user.birth;
        // 从cookie中获取医院信息
        const hospitalData = this.$cookie.get('currentHospital');
        const hospital = hospitalData ? JSON.parse(hospitalData).name : '';

        // 创建文件对象
        const reportFile = new File([pdfBlob.blob], pdfBlob.title + '.pdf', {
          type: 'application/pdf'
        });

        // 调用上传API
        const result = await this.$http.admin.uploadPdfReport(
          patientName,
          gender,
          birthday,
          hospital,
          checkList,
          reportFile
        );
        console.log("result", result);

        if (result) {
          this.$message.success('报告上传成功！');
          // 上传成功后，将SHA256值缓存到本地
          localStorage.setItem('cachedReportHash', sha256Hash);
        }
      } catch (error) {
        console.error('上传PDF报告失败:', error);
        this.$message.error('报告上传失败，请重试！');
      }
    },
    download() {
      this.uploadPdfReport();
      this.getPdf("#pdfDom");
    },
    drawLine(lineData, normalArr) {
      const shadowData = [
        ["3", normalArr[0][0]],
        ["6", normalArr[1][0]],
        ["12", normalArr[2][0]],
        ["18", normalArr[3][0]],
        ["18", normalArr[3][1]],
        ["12", normalArr[2][1]],
        ["6", normalArr[1][1]],
        ["3", normalArr[0][1]],
        ["3", normalArr[0][0]]
      ];
      const result = [];
      if (lineData.length > 0) {
        lineData.forEach(item => {
          console.log("item>>>>>", item);
          const chartComponent = this.$refs.visionChallengeResult;

          const yData = item.data.map(o => {
            return ["" + o[0], o[1]];
          });
          let myChart = this.$echarts.init(chartComponent);
          myChart.setOption({
            title: {
              text: mapEyes[item.type],
              textStyle: {
                color: "#000000",
                fontSize: 14,
                fontWeight: 400
              }
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              name: "空间频率",
              nameLocation: "center",
              nameGap: 25,
              data: ["0", "3", "6", "12", "18", ""]
            },
            grid: {
              left: "15%",
              right: "0",
              bottom: "25%"
            },
            yAxis: {
              type: "value",
              name: "对比敏感度",
              nameLocation: "center",
              nameGap: 35
            },
            animation: false,
            series: [
              {
                data: shadowData,
                type: "line",
                areaStyle: {
                  color: "gray"
                },
                symbol: "none",
                lineStyle: {
                  color: "gray"
                }
              },
              {
                data: yData,
                type: "line",
                lineStyle: {
                  color: "green"
                }
              }
            ]
          });
          result.push(myChart.getDataURL());
        });
      }

      this.$nextTick(() => {
        var picInfo = result;
        this.picInfo = picInfo;
        console.log(">>>>>", result);
        this.checkResult.picInfo = picInfo;
        if (picInfo) {
          let jsonData = JSON.stringify({
            type: "getImage",
            data: picInfo
          });
          window.frames[0].postMessage(jsonData, "*");
        }
        this.showResultImg = false;
      });
    },
    quitShowReport() {
      this.showQuitAlert = false;
      exitFullScreen();
      this.showCheckReport = true;
    },
    jumpTest() {
      if (this.checkList.length > 0) {
        const activeItem = this.checkList.shift();
        this.iframeElement.src = `${this.$resourceUrl}${basicLink[activeItem]}`;
        this.activeItem = activeItem;
      }
      this.finished = false;
      this.showQuitAlert = false;
    },
    cancelPrint() {
      this.showCheckReport = false;
      this.goBack();
    }
  }
};
</script>
<template>
  <div
    class="TrainIframe"
    v-loading.fullscreen.lock="!finished"
    element-loading-background="rgba(0, 0, 0, 0.3)"
  >
    <div v-if="showResultImg" ref="visionChallengeResult" style="width: 300px;height: 200px;"></div>
    <operationDialog
      :Visible="showCheckReport"
      title="检测报告"
      class="showCheckReportDialog"
      @confirm="print"
      @close="cancelPrint"
      width="1200px"
      btnText="打印"
      btnText2="下载PDF"
      @confirm2="download"
    >
      <div class="showCheckReportDialogBody">
        <section id="pdfDom" ref="print" style="width: 1000px;margin: 0px auto;">
          <newCheckReport
            style="width: 800px;margin: 70px auto;"
            :testUser="user"
            :testResult="checkResult"
          />
        </section>
      </div>
    </operationDialog>
    <div class="container">
      <operationDialog
        :Visible="showQuitAlert"
        title="检测到尚未完成检测！"
        class="showCheckReportDialog"
        :showClose="false"
        @confirm="quitShowReport"
        @close="showQuitAlert = false"
        width="300px"
        btnText="直接查看报告"
        btnText2="跳过本关"
        @confirm2="jumpTest"
      />
      <iframe class="ScreenIframe" frameborder="no"></iframe>
    </div>
  </div>
</template>

<style lang="scss">
.TrainIframe .container {
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #00c1de;
  }

  .el-input__inner:focus {
    border-color: #00c1de;
  }
}
.showCheckReportDialog {
  .operationDialog .el-dialog__header {
    text-align: center;
  }
  .operationDialog .el-dialog__body {
    max-height: 350px;
    overflow-y: auto;
  }

  .showCheckReportDialogForm {
    padding: 10px 10px 15px 15px;

    .el-form-item__label {
      font-size: 16px;
      color: rgba(54, 54, 54, 1);
    }

    .el-input--small {
      width: 250px;
    }

    .el-input--small .el-input__inner {
      width: 250px;
    }
  }
}
</style>
<style lang="scss" scoped>
.el-select-dropdown__item.selected {
  color: #00c1de;
}

.TrainIframe {
  width: 99%;
  height: 96%;
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  flex-grow: 1;
  // margin: 15px;
  background-color: #fff;
  border-radius: 5px;
  // overflow: auto;
}

.ScreenIframe {
  width: 100%;
  height: 100%;
}

.text {
  margin-bottom: 24px;
  margin: 0 23px 24px 23px;
  text-align: center;
  color: #343434;
  font-size: 18px;

  .selectBox {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vision/batchCheck.vue